import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from './models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient) {}


  getRoles() {
    return this.http.get<ApiResponseModel>('/api/user/role');
  }
  languages() {
    return this.http.get<ApiResponseModel>('/api/locale/languages');
  }
  fileUpload(body) {
    return this.http.post<ApiResponseModel>('/api/file', body);
  }
  getAllCountries() {
    return this.http.get<ApiResponseModel>('api/location/countries');
  }
  getAllCities(id) {
    return this.http.get<ApiResponseModel>(
      'api/location/cities?countryId=' + id
    );
  }
  addTag(body) {
    return this.http.post<ApiResponseModel>('/api/tag', body);
  }
}
